module.exports = __webpack_public_path__ + "components/flag/static/square/mo-606b41aae2f36c165285f4bc7845c0ab.svg";